import { IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";

import { DEFAULT_ICONS_V2 } from "@/constants";
import { iconsSelector } from "@/store/selectors";
import { getMediaLink } from "@/utils/mediaLink";

const useStyles = makeStyles({
  iconsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 16,
    marginBottom: 32,
  },
  icons: {
    display: "flex",
    gap: 16,
    "& img": {
      maxWidth: 24,
      maxHeight: 24,
    },
  },
  noCustomIcons: {
    color: "#757575",
    margin: "8px 0px 8px 16px",
  },
  iconButtonRoot: {
    border: "2px solid #757575",
    padding: "8px !important",
    width: 40,
    height: 40,

    "&:hover": {
      border: "2px solid #F50561",
    },
  },
  iconButtonRootActive: {
    border: "2px solid #F50561",
  },
});

export default function ElementIconField(props) {
  const { propertyId, formValues, setValue } = props;
  const classes = useStyles();

  const { icons: customIcons } = useSelector(iconsSelector(propertyId));

  const defaultIcons = Object.keys(DEFAULT_ICONS_V2).map((key) => {
    return { name: key, link: DEFAULT_ICONS_V2[key] };
  });

  const handleClick = (icon) => {
    setValue("iconName", icon.name, { shouldDirty: true });
    setValue("iconLink", icon.link, { shouldDirty: true });
  };

  return (
    <>
      <div className={classes.iconsContainer} data-testid="element-default-icons-container">
        <span>Default Icons</span>
        <div className={classes.icons}>
          {defaultIcons.map((icon) => {
            const { name, link } = icon;

            return (
              <IconButton
                key={name}
                data-testid={`element-default-icon-${name}`}
                disableRipple
                onClick={() => handleClick(icon)}
                classes={{
                  root: `${classes.iconButtonRoot} ${name === formValues.iconName ? classes.iconButtonRootActive : ""}`,
                }}
              >
                <img src={link} alt={name} />
              </IconButton>
            );
          })}
        </div>
      </div>
      <div className={classes.iconsContainer} data-testid="element-custom-icons-container">
        <span>Custom Icons</span>
        <div className={classes.icons}>
          {customIcons.length ? (
            customIcons.map((icon) => {
              const { name, link } = icon;

              return (
                <IconButton
                  key={name}
                  disableRipple
                  onClick={() => handleClick(icon)}
                  classes={{
                    root: `${classes.iconButtonRoot} ${name === formValues.iconName ? classes.iconButtonRootActive : ""}`,
                  }}
                >
                  <img src={getMediaLink({ link })} alt={name} />
                </IconButton>
              );
            })
          ) : (
            <span className={classes.noCustomIcons}>Uploaded custom icons will appear here. </span>
          )}
        </div>
      </div>
    </>
  );
}
